// Footer.js
import React, { Component } from 'react';
// import { NavLink } from 'react-router-dom';
import webservice from '../services/webservice';
import { Api } from '../common/variables';
import ThreeRowContent from '../components/content/three-col-content/three-row-content';

// Language
import utils from '../common/utils';

// Redux set data
import { connect } from "react-redux";

class Footer extends Component {
	constructor() {
		let newDate = new Date();
		// let date = newDate.getDate();
		// let month = newDate.getMonth() + 1;
		let year = newDate.getFullYear();

		super()
		this.state = {
			name: '',
			addressList: '',
			vendor_phone: '',
			contact_email: '',
			vendor_phone_alt: '',
			currentDate: year,
			aboutcompany: '',
			whychooseus: '',
			contactus: '',
		};
	}

	async componentDidMount() {
		let params = {
			lang: this.props.language,
			vendorID: this.props.vendorInfos.data.id
		}

		let footerMenu = await webservice.httpPost(Api.method.getFooterNavMenu, params);
		if (footerMenu.status === 'ok' && footerMenu.data.length > 0) {
			this.setState({
				footerMenus: footerMenu.data,
				footerMenuApi: true,
			})
		}

		if ( 'ok' === this.props.vendorInfos.status ) {
			this.setState({
				name: this.props.vendorInfos.data.name,
				facebook: this.props.vendorInfos.data.facebook,
				addressList: this.props.vendorInfos.data.addressList,
				contact_email: this.props.vendorInfos.data.contact_email,
				vendor_phone: this.props.vendorInfos.data.vendor_phone,
				vendor_phone_alt: this.props.vendorInfos.data.vendor_phone_alt,
				aboutcompany: this.props.vendorInfos.data.AboutCompany,
				whychooseus: this.props.vendorInfos.data.WhyChooseUs,
				contactus: this.props.vendorInfos.data.ContactUs,
			});
		}

		let searchParams = {
			vendorID : this.props.vendorInfos.data.id,
		}

		// save search keywords
		let getPopularSearchKeywords = await webservice.httpPost( Api.method.getPopularSearchKeywords, searchParams );
		if ( 'ok' === getPopularSearchKeywords.status && getPopularSearchKeywords.data.length > 0 ) {
			this.setState({
				popularSearches: getPopularSearchKeywords.data
			})
		}
	}
	render() {
		return (
			<div className="footer-wrapper">
				<footer>
					<div className="footer_bottom">
						<div className="wrapper wrapper_1200">
							<div className="d-flex">
								<div className="footer_bottom-center">
									{/*<div className="fb_r1">
										<div className="fb_c1">
											<img src={require('../assets/images/Gharbanau_qr.png')} width='87' alt="QR Code" />
											<a href="https://apps.apple.com/np/app/gharbanau/id1490745630" target="_blank" rel="noopener noreferrer">
												<img src={require('../assets/images/apple-app.jpg')} alt="Apple Icon" />
											</a>
										</div>
										<div className="fb_c2">
											<div style={{ padding: 5, width: 120, backgroundColor: 'white', marginLeft: 10, marginBottom: 10, borderRadius: 4, }}>
												<img src={require('../assets/images/gharbanau-logo.png')} alt="Gharbanau Icon" style={{ margin: 0 }} />
											</div>
											<a href="https://play.google.com/store/apps/details?id=com.gharbanau" target="_blank" rel="noopener noreferrer">
												<img src={require('../assets/images/Play-Store.jpg')} alt="Playstore" />
											</a>
										</div>
									</div>
									<div className="fb_r2">
										<img src={require('../assets/images/dowload-mobile-app.svg')} alt="Download mobile app" />
										<p>{utils.Language('lang_footerDownloadText', this.props.language)}</p>
									</div>*/}
									<div className="quick_links">
										<span className="footer_link-title">{utils.Language('lang_quickLinks', this.props.language)}</span>
										{
											(this.state.aboutcompany) ?
												<a className={ ( 'about-company' === window.location.pathname.split('/')[1] ) ? "footer_menu active" : "footer_menu" } href={'/about-company'}>{utils.Language('lang_AboutCompany', this.props.language)}</a>
												: null
										}
										{
											(this.state.whychooseus) ?
												<a className={ ( 'why-choose-us' === window.location.pathname.split('/')[1] ) ? "footer_menu active" : "footer_menu" } href={'/why-choose-us'}>{utils.Language('lang_WhyChooseUs', this.props.language)}</a>
												: null
										}
										{
											(this.state.contactus) ?
												<a className={ ( 'contact-us' === window.location.pathname.split('/')[1] ) ? "footer_menu active" : "footer_menu" } href={'/contact-us'}>{utils.Language('lang_contactUs', this.props.language)}</a>
												: null
										}
										{
										(this.state.footerMenuApi) ?
											this.state.footerMenus.map((data, index) => {
												return (
													<a href={'/' + encodeURIComponent(data.Page_Identifier)} key={index} className={ ( window.location.pathname.split('/')[1] === encodeURIComponent( data.Page_Identifier ) ) ? "footer_menu active" : "footer_menu" }>{('En' === this.props.language) ? data.Page_Title_En : data.Page_Title_Np}</a>
												)
											})
										: null
										}
									</div>
								</div>

								<div className="footer_bottom-left">
									<div id="footer_bottom-right" style={{ display: 'block' }}>
										<span className="footer_link-title">{utils.Language('lang_contactUs', this.props.language)}</span>
										<div className="footer_address">
											<p>{this.state.name}<br />
												{this.state.addressList}</p>
										</div>

										<div className="footer_social_icons">
										<div className="footer_phone-div footer_phone-div-call">
												<svg className="phone-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 13.744 13.732"><defs></defs><path className="a" d="M35.385,36.608a10.8,10.8,0,0,0,2.3,3.12,12.038,12.038,0,0,0,2.41,1.646c.077.042.108,0,.15-.041.305-.306.619-.6.915-.919a1.088,1.088,0,0,1,1.087-.325,1.6,1.6,0,0,1,.686.3,11.309,11.309,0,0,1,1.9,1.9,1.516,1.516,0,0,1,.328,1.2,1,1,0,0,1-.192.439,3.607,3.607,0,0,1-2.273,1.35,4.074,4.074,0,0,1-1.5-.081,9.735,9.735,0,0,1-3.7-1.637,18.734,18.734,0,0,1-4.91-5.051,6.544,6.544,0,0,1-1.063-2.633,4.68,4.68,0,0,1,.391-2.962,3.559,3.559,0,0,1,.992-1.129,1.265,1.265,0,0,1,1.446.062,14.667,14.667,0,0,1,1.93,1.841,1.858,1.858,0,0,1,.468,1.129.938.938,0,0,1-.295.739q-.486.485-.973.97A.837.837,0,0,1,35.385,36.608Z" transform="translate(-31.445 -31.594)" /></svg>

												<div className="footer_phones">
													{( this.state.vendor_phone ) ? <a href={"tel:" + this.state.vendor_phone } > { this.state.vendor_phone } </a>  :null }
													{( this.state.vendor_phone_alt ) ? <a href={"tel:" + this.state.vendor_phone_alt } > { this.state.vendor_phone_alt } </a>  :null }
												</div>
										</div>
										{
											( this.state.vendor_phone ) ?
											<div className="footer_phone-div footer_phone-div-whatsapp">
													<a href={"viber://chat?number=" + this.state.vendor_phone} >
														<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">
															<path className="a" d="M 44.78125 13.15625 C 44 10.367188 42.453125 8.164063 40.1875 6.605469 C 37.328125 4.632813 34.039063 3.9375 31.199219 3.511719 C 27.269531 2.925781 23.710938 2.84375 20.316406 3.257813 C 17.136719 3.648438 14.742188 4.269531 12.558594 5.273438 C 8.277344 7.242188 5.707031 10.425781 4.921875 14.734375 C 4.539063 16.828125 4.28125 18.71875 4.132813 20.523438 C 3.789063 24.695313 4.101563 28.386719 5.085938 31.808594 C 6.046875 35.144531 7.722656 37.527344 10.210938 39.09375 C 10.84375 39.492188 11.65625 39.78125 12.441406 40.058594 C 12.886719 40.214844 13.320313 40.367188 13.675781 40.535156 C 14.003906 40.6875 14.003906 40.714844 14 40.988281 C 13.972656 43.359375 14 48.007813 14 48.007813 L 14.007813 49 L 15.789063 49 L 16.078125 48.71875 C 16.269531 48.539063 20.683594 44.273438 22.257813 42.554688 L 22.472656 42.316406 C 22.742188 42.003906 22.742188 42.003906 23.019531 42 C 25.144531 41.957031 27.316406 41.875 29.472656 41.757813 C 32.085938 41.617188 35.113281 41.363281 37.964844 40.175781 C 40.574219 39.085938 42.480469 37.355469 43.625 35.035156 C 44.820313 32.613281 45.527344 29.992188 45.792969 27.019531 C 46.261719 21.792969 45.929688 17.257813 44.78125 13.15625 Z M 35.382813 33.480469 C 34.726563 34.546875 33.75 35.289063 32.597656 35.769531 C 31.753906 36.121094 30.894531 36.046875 30.0625 35.695313 C 23.097656 32.746094 17.632813 28.101563 14.023438 21.421875 C 13.277344 20.046875 12.761719 18.546875 12.167969 17.09375 C 12.046875 16.796875 12.054688 16.445313 12 16.117188 C 12.050781 13.769531 13.851563 12.445313 15.671875 12.046875 C 16.367188 11.890625 16.984375 12.136719 17.5 12.632813 C 18.929688 13.992188 20.058594 15.574219 20.910156 17.347656 C 21.28125 18.125 21.113281 18.8125 20.480469 19.390625 C 20.347656 19.511719 20.210938 19.621094 20.066406 19.730469 C 18.621094 20.816406 18.410156 21.640625 19.179688 23.277344 C 20.492188 26.0625 22.671875 27.933594 25.488281 29.09375 C 26.230469 29.398438 26.929688 29.246094 27.496094 28.644531 C 27.574219 28.566406 27.660156 28.488281 27.714844 28.394531 C 28.824219 26.542969 30.4375 26.726563 31.925781 27.78125 C 32.902344 28.476563 33.851563 29.210938 34.816406 29.917969 C 36.289063 31 36.277344 32.015625 35.382813 33.480469 Z M 26.144531 15 C 25.816406 15 25.488281 15.027344 25.164063 15.082031 C 24.617188 15.171875 24.105469 14.804688 24.011719 14.257813 C 23.921875 13.714844 24.289063 13.199219 24.835938 13.109375 C 25.265625 13.035156 25.707031 13 26.144531 13 C 30.476563 13 34 16.523438 34 20.855469 C 34 21.296875 33.964844 21.738281 33.890625 22.164063 C 33.808594 22.652344 33.386719 23 32.90625 23 C 32.851563 23 32.796875 22.996094 32.738281 22.984375 C 32.195313 22.894531 31.828125 22.378906 31.917969 21.835938 C 31.972656 21.515625 32 21.1875 32 20.855469 C 32 17.628906 29.371094 15 26.144531 15 Z M 31 21 C 31 21.550781 30.550781 22 30 22 C 29.449219 22 29 21.550781 29 21 C 29 19.347656 27.652344 18 26 18 C 25.449219 18 25 17.550781 25 17 C 25 16.449219 25.449219 16 26 16 C 28.757813 16 31 18.242188 31 21 Z M 36.710938 23.222656 C 36.605469 23.6875 36.191406 24 35.734375 24 C 35.660156 24 35.585938 23.992188 35.511719 23.976563 C 34.972656 23.851563 34.636719 23.316406 34.757813 22.777344 C 34.902344 22.140625 34.976563 21.480469 34.976563 20.816406 C 34.976563 15.957031 31.019531 12 26.160156 12 C 25.496094 12 24.835938 12.074219 24.199219 12.21875 C 23.660156 12.34375 23.125 12.003906 23.003906 11.464844 C 22.878906 10.925781 23.21875 10.390625 23.757813 10.269531 C 24.539063 10.089844 25.347656 10 26.160156 10 C 32.125 10 36.976563 14.851563 36.976563 20.816406 C 36.976563 21.628906 36.886719 22.4375 36.710938 23.222656 Z">
															</path>
														</svg>

													</a>
													<div className="footer_phones">
														{ this.state.vendor_phone }
													</div>
											</div>
											:null
										}
										{
											( this.state.contact_email ) ?
											<div className="footer_email footer_email-mail">
												<a href={"mailto:" + this.state.contact_email} style={{ pointerEvents: 'all' }}>
													<svg width="16" height="10.814" viewBox="0 0 16 10.814"><defs></defs><g transform="translate(-20.058 -81.683)"><path className="a" d="M37.057,88.278,29.487,81.9a1.083,1.083,0,0,1,.658-.222H43.967a1.085,1.085,0,0,1,.675.234Z" transform="translate(-8.998)" /><path className="a" d="M36.058,111.195v8.352a1.089,1.089,0,0,1-1.089,1.089H21.147a1.089,1.089,0,0,1-1.089-1.089V111.17l8,6.735Z" transform="translate(0 -28.139)" /></g>
													</svg>
													
													<div className="footer_mail">{ this.state.contact_email }</div>
												</a>
												
											</div>
											:null
										}
										{
											( this.state.facebook ) ?
											<div className="footer_email footer_email-fb">
												<a href={ this.state.facebook } target="_blank" rel="noopener noreferrer" className="social icon_fb" style={{ pointerEvents: 'all' }}>
													<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">
														<path className="a" d="M32,11h5c0.552,0,1-0.448,1-1V3.263c0-0.524-0.403-0.96-0.925-0.997C35.484,2.153,32.376,2,30.141,2C24,2,20,5.68,20,12.368 V19h-7c-0.552,0-1,0.448-1,1v7c0,0.552,0.448,1,1,1h7v19c0,0.552,0.448,1,1,1h7c0.552,0,1-0.448,1-1V28h7.222 c0.51,0,0.938-0.383,0.994-0.89l0.778-7C38.06,19.518,37.596,19,37,19h-8v-5C29,12.343,30.343,11,32,11z">
														</path>
													</svg>
												<div className="footer_mail">
													{ this.state.facebook }
												</div>	
												</a>
												
											</div>
											:null
										}
									</div>
										
									</div>
								</div>

								<div className="footer_bottom-right">
									<ThreeRowContent />
								</div>
							</div>

							{
								( this.state.popularSearches && this.state.popularSearches.length > 0 ) ?
								<div className="popular-searches">
									<span className="footer_link-title title-withline"><span className="wrapwhite">{utils.Language('lang_popularSearches', this.props.language)}</span></span>
									{
									this.state.popularSearches.map( ( words, index ) => {
										return(
											<a href={ '/search?keyword=' + words } className="searchkeywords footer_menu" key={index}>{ words }</a>
										)
									})
									}
								</div>
								: null
							}
						</div>
					</div>
					<div className="copyright">
						<p>{utils.Language('lang_bottomFooterImageInfo', this.props.language)}</p>
						<p><span className="icon-copyright"></span> {utils.Language('lang_bottomFooterCopyright', this.props.language)} {this.state.currentDate} {utils.Language('lang_bottomFooterCopyrightdesc', this.props.language)} <a href="https://www.tulipstechnologies.com/" target="_blank" rel="noopener noreferrer" className="linkText-white">{utils.Language('lang_companyName', this.props.language)}</a>.</p>
					</div>
				</footer>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	...state
});

export default connect(mapStateToProps, null)(Footer);